import { render } from "./IHeaderTrack.vue?vue&type=template&id=e8020bae"
import script from "./IHeaderTrack.vue?vue&type=script&lang=js"
export * from "./IHeaderTrack.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ilya/Documents/Web/github/iTunes-Vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__